import { useTranslation } from '@thoughtspot/i18n';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { isRolesEnabled } from '@thoughtspot/session-service';
import React, { Fragment, useEffect, useState } from 'react';
import { useGetRolesLazyQuery } from "../../../../services/role/role-service";
import { TranslationsKeys } from '../util';
import styles from './view-roles-privilege-modal.module.scss';
export const ViewRolesPrivilegesModal = ({ closeModal, }) => {
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [roles, setRoles] = useState([]);
    const roleListParams = {
        sortascending: true,
        batchsize: 200,
        offset: 0,
        pattern: '',
    };
    const { data: rolesData, error: rolesError, loading: rolesLoading, getRoles, } = useGetRolesLazyQuery(roleListParams);
    const onDismissModal = () => {
        setIsModalOpen(false);
        closeModal();
    };
    useEffect(() => {
        if (isRolesEnabled()) {
            getRoles();
        }
    }, []);
    useEffect(() => {
        if (!rolesLoading && rolesData) {
            setRoles(rolesData.Data?.roles);
        }
    }, [rolesData, rolesLoading]);
    const modalProps = {
        size: ModalSize.MEDIUM,
        title: t(TranslationsKeys.ALL_ROLES_PRIVILEGES),
        onDismiss: onDismissModal,
        isOpen: isModalOpen,
        confirmButton: {
            text: t(TranslationsKeys.BACK),
            onConfirm: () => {
                closeModal();
            },
        },
        className: styles.modalProps,
        autoScrollContent: true,
        contentClassName: styles.modalContentClassName,
        customHeaderClassName: styles.customHeader,
        customFooterClassName: styles.customFooter,
    };
    const renderItemForReviewPrivilege = (privilege) => (React.createElement(Horizontal, { key: privilege },
        React.createElement(Typography, { variant: "body-large", overrideTag: "div", color: Colors.grayLight, className: styles.privilegeItem }, getTranslations(`tennablePrivilegesLabels.${privilege}`))));
    const renderPrivileges = () => roles.map((record) => {
        const privileges = record.privileges;
        return (React.createElement(Fragment, { key: record.name }, privileges?.length > 0 && (React.createElement(Vertical, { className: styles.privilegeGroupContainer },
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "section-label", overrideTag: "div", className: styles.privilegeGroupHeader }, record.name)),
            React.createElement(Vertical, { className: styles.privilegeItemContainer }, privileges.length ? (privileges?.map((item) => renderItemForReviewPrivilege(item))) : (React.createElement(Horizontal, null,
                React.createElement(Typography, { variant: "body-large", overrideTag: "div", color: Colors.grayLight, className: styles.privilegeItem }, t(TranslationsKeys.NO_PRIVILEGE_ASSIGNED)))))))));
    }) || null;
    return (React.createElement(React.Fragment, null, roles && (React.createElement(Modal, { ...modalProps },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true, className: styles.container },
            React.createElement("div", { "data-testid": "rolesModal_view" },
                React.createElement(Vertical, { className: styles.mainContainer }, renderPrivileges())))))));
};
//# sourceMappingURL=view-roles-privilege-modal.container.js.map